import { translate } from '../../../common/utility/DisplayPrep';

const defaultUiConfig = {
    name: 'Code Systems',
    withActions: [],
    primaryKey: 'codeSystemId',
    pageSize: 10,
    properties: {
        oid: {
            sortable: true,
            name: 'Oid',
            rowDisplay: false
            // accessorOverride: (v) => {
            //     if (v.mappingType === 'Value Set') {
            //         return v.valueSetDTO.oid;
            //     } else if (v.mappingType === 'Code') {
            //         return v.cdsCodeSystemDTO.oid;
            //     } else {
            //         return '';
            //     }
            // }
        },
        name: {
            name: 'Name',
            sortable: true,
            rowDisplay: false
            // accessorOverride: (v) => {
            //     // For now we must use the formatted value until we resolve display prep
            //     if (v.mappingType === 'Value Set') {
            //         return v.valueSetDTO.name;
            //     } else if (v.mappingType === 'Code') {
            //         return v.cdsCodeSystemDTO.name;
            //     } else {
            //         return '';
            //     }
            // }
        },
        codeSystemId: {
            name: 'Code System ID',
            sortable: true,
            nullable: false
        },
        auditId: {
            name: 'Audit ID',
            sortable: true,
            rowDisplay: false
        },
        uuid: {
            rowDisplay: false,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: true,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        }
    },
    newDoc: {
        auditId: null,
        codeSystemId: null,
        codes: [],
        createDatetime: null,
        createId: null,
        dtoState: 'NEW',
        lastModDatetime: null,
        lastModId: null,
        name: null,
        oid: null
    }
};

export default defaultUiConfig;
